
import React from "react";
import { Link, useParams } from "react-router-dom";
import { EmptyState, ParentPageHeader, PortalLoading, StatusBadge, useParentPortal } from "./parentPortalUtils";

function ParentChildResultsPage() {
  const { studentId } = useParams();
  const { data, loading, reload } = useParentPortal(`parent-portal/children/${studentId}/results/`);
  if (loading && !data) return <PortalLoading />;

  const sessions = data?.sessions || [];

  return (
    <div className="container-fluid py-4">
      <ParentPageHeader title="Results & Reports" subtitle={data?.student?.full_name || "Published academic reports"} icon="bi-journal-check" actions={<button className="btn btn-light border" onClick={reload}>Refresh</button>} />
      {data?.message && <div className="alert alert-warning border">{data.message}</div>}
      <div className="card border-0 shadow-sm"><div className="card-body">
        {sessions.length === 0 ? <EmptyState title="No published reports" message="Published reports will appear here when released by the school." /> : (
          <div className="table-responsive"><table className="table align-middle"><thead className="table-light"><tr><th>Session</th><th>Academic Year</th><th>Term</th><th>Marks</th><th>Status</th><th>Action</th></tr></thead><tbody>{sessions.map(session => <tr key={session.id}><td className="fw-semibold">{session.name}</td><td>{session.academic_year || "-"}</td><td>{session.term || "-"}</td><td>{session.marks_count}</td><td><StatusBadge value={session.can_view ? "Available" : "Restricted"} /></td><td>{session.can_download_report ? <Link className="btn btn-sm btn-success" to={`/parent/children/${studentId}/results/report/${session.id}`}>View / Download</Link> : <span className="text-muted small">{session.message || "Not available"}</span>}</td></tr>)}</tbody></table></div>
        )}
      </div></div>
    </div>
  );
}

export default ParentChildResultsPage;
